/**
 * 安全配置 - 修改导航组件
*/

import { Row, Col, Button } from 'antd';
import CNF from '../../incs/Config.js';
import Logo from '../../images/logo.png';

const FindPasswordNav = (props) => {
    return (
        <>
            <Row style={{ color: '#FFFFFF', backgroundColor: '#001529' }}>
                <Col span={3} offset={5}>
                    <img src={Logo} style={{ height: '60px', marginTop: '20px' }} alt='' />
                </Col>
                <Col span={6}>
                    <h3 style={{ lineHeight: '60px' }}>{props.title}</h3>
                </Col>
                <Col span={3} style={{ lineHeight: '100px' }}>
                    <span>您好，请完成下面步骤！</span>
                    <span style={{ color: '#FFFFFF', float: 'right' }}>|</span>
                </Col>
                <Col span={1} style={{ textAlign: 'center', lineHeight: '100px' }}>
                    <Button type='link' style={{ color: '#FFFFFF' }} href={CNF.loginUrl}>返回</Button>
                </Col>
                <Col span={1} style={{ textAlign: 'center', lineHeight: '100px' }}>
                    <Button type='link' style={{ color: '#FFFFFF' }}>帮助</Button>
                </Col>
            </Row>
        </>
    );
}

export default FindPasswordNav;